import { useState, useCallback } from 'react';
import { NotificationData, notificationApi } from '../services/notificationApi';

export const useNotifications = () => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const checkForNotifications = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    try {
      const unreadNotifications = await notificationApi.getUnreadNotifications();
      setNotifications(unreadNotifications);
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      setNotifications([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const removeNotification = useCallback((notificationId: string) => {
    setNotifications(prev => prev.filter(n => n.id !== notificationId));
  }, []);

  return {
    notifications,
    isLoading,
    hasNotifications: notifications.length > 0,
    checkForNotifications,
    clearNotifications,
    removeNotification,
  };
};